"use client";
import React, { type FC } from "react";
import { Toaster } from "sonner";

const ToasterWrapper: FC = () => {
  return (
    <Toaster
      richColors
      position="top-center"
      toastOptions={{
        className: "app-text-body2 w-fit",
      }}
    />
  );
};

export default ToasterWrapper;
